import React, { Component } from 'react';
import { Modal, Input, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import '../style.less';

class RateEdit extends Component {
    state = {
        record: {},
        invList: [],
        saveParams: {},
        visible: false,
    }

    show = (record) => {
        this.setState({
            visible: true,
            saveParams: {...record},
        },);
    }

    cancel = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { saveParams } = this.state;
        const {
            currencyExchangeRateId,
            exchangeRate,
        } = saveParams;
        var z_reg = /^(\-|\+)?\d+(\.\d+)?$/;
        if (!exchangeRate) {
            message.warning('请输入汇率');
            return;
        }
        if(!z_reg.test(exchangeRate))
        {
            message.warning('请输入正确的汇率');
            return;
        }
        this.setState({ loading: true });
        let url = API_URL.contract.updateExchangeRate;
        const options = {
            method: 'post',
            url,
            data: {
                currencyExchangeRateId,
                exchangeRate,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                    visible: false,
                }, () => {
                    this.props.loadData();
                })
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleInputChange = (e, key) => {
        const { saveParams } = this.state;
        saveParams[key] = e.target.value;
        this.setState({ saveParams });
    }

    render () {
        const { visible, saveParams } = this.state;
        const {dateShow, currencyName, currencyCode, exchangeRate } = saveParams;
        const asterisk = <span style={{color: 'red'}}>*</span>;
        return (
            <Modal
                title="修改汇率"
                visible={visible}
                onOk={this.submit}
                onCancel={this.cancel}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="450px"
            >
                <div className="rate-edit">
                    <ul className="preview-list apply-jde">
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">生效日期</label>
                                <span className="ui-text">
                                {dateShow}
                                </span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">币种</label>
                                <span className="ui-text">
                                {currencyName}
                                </span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">币种代码</label>
                                <span className="ui-text">
                                {currencyCode}
                                </span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item rate-item">
                                <label className="ui-label">{asterisk}汇率</label>
                                <span className="ui-text">
                                    1{currencyName}=
                                    <Input
                                        placeholder="请输入"
                                        style={{width: 120,margin:'0px 5px' }}
                                        value={exchangeRate}
                                        onChange={e => this.handleInputChange(e, 'exchangeRate')}
                                    />人民币
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}

export { RateEdit } ;


// WEBPACK FOOTER //
// ./src/components/contractManagement/currencyExchangeRate/RateEdit.js